/* Notificações — a confirmação do que acabou de acontecer.
 *
 * O design system é explícito sobre o tom: "Você assumiu a conversa" é um
 * fato, não uma comemoração. Nada de "Pronto!", nada de emoji.
 *
 * Somem sozinhas depois de alguns segundos, **menos as de erro**: um erro que
 * desaparece antes de ser lido é a mesma coisa que erro nenhum, e quem está
 * atendendo costuma estar olhando para outra parte da tela.
 */

import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const Contexto = createContext(null);

const SEGUNDOS_ATE_SUMIR = 6000;

export function ProvedorNotificacoes({ children }) {
  const [itens, definirItens] = useState([]);
  const proximo = useRef(1);

  const fechar = useCallback((id) => {
    definirItens((atuais) => atuais.filter((n) => n.id !== id));
  }, []);

  const notificar = useCallback(
    ({ tom = 'neutro', titulo, descricao, acao, aoAcao }) => {
      const id = proximo.current++;
      definirItens((atuais) => [...atuais, { id, tom, titulo, descricao, acao, aoAcao }]);

      if (tom !== 'erro') {
        setTimeout(() => fechar(id), SEGUNDOS_ATE_SUMIR);
      }

      return id;
    },
    [fechar],
  );

  const valor = useMemo(
    () => ({
      itens,
      fechar,
      notificar,
      confirmar: (titulo, descricao) => notificar({ tom: 'sucesso', titulo, descricao }),
      /** Erro fica na tela até alguém fechar. */
      falhar: (titulo, descricao) => notificar({ tom: 'erro', titulo, descricao }),
    }),
    [itens, fechar, notificar],
  );

  return <Contexto.Provider value={valor}>{children}</Contexto.Provider>;
}

export function useNotificacoes() {
  const contexto = useContext(Contexto);
  if (!contexto) throw new Error('useNotificacoes fora do ProvedorNotificacoes');
  return contexto;
}
